<script setup>
import { ref, watch } from 'vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import { MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS } from 'dashboard/constants/editor';
import FormButton from 'v3/components/Form/Button.vue';

const props = defineProps({
  messageSignature: {
    type: String,
    default: '',
  },
  signatureType: {
    type: String,
    default: 'global',
    validator: value => ['global', 'email'].includes(value),
  },
});

const emit = defineEmits(['updateSignature', 'update:signatureType']);
const customEditorMenuList = MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS;
const signatureTypes = [
  {
    value: 'global',
    labelKey: 'PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.TYPES.GLOBAL',
    icon: 'i-ph-chat-circle-text',
  },
  {
    value: 'email',
    labelKey: 'PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.TYPES.EMAIL',
    icon: 'i-ph-envelope-simple',
  },
];
const signature = ref(props.messageSignature);
watch(
  () => props.messageSignature ?? '',
  newValue => {
    signature.value = newValue;
  }
);

const updateSignature = () => {
  emit('updateSignature', signature.value);
};

const updateSignatureType = type => {
  emit('update:signatureType', type);
};
</script>

<template>
  <form class="flex flex-col gap-6" @submit.prevent="updateSignature()">
    <div
      class="inline-flex self-start gap-1 rounded-lg border border-n-weak bg-n-alpha-black2 p-1"
    >
      <button
        v-for="type in signatureTypes"
        :key="type.value"
        type="button"
        class="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-n-slate-11 transition-colors hover:text-n-slate-12"
        :class="
          signatureType === type.value
            ? 'bg-n-alpha-2 text-n-slate-12 shadow-sm'
            : ''
        "
        :aria-pressed="signatureType === type.value"
        @click="updateSignatureType(type.value)"
      >
        <span :class="type.icon" class="text-base" />
        {{ $t(type.labelKey) }}
      </button>
    </div>
    <WootMessageEditor
      :key="signatureType"
      id="message-signature-input"
      v-model="signature"
      class="message-editor h-[10rem] !px-3"
      is-format-mode
      :placeholder="$t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE.PLACEHOLDER')"
      :enabled-menu-options="customEditorMenuList"
      :enable-suggestions="false"
      show-image-resize-toolbar
    />
    <FormButton
      type="submit"
      color-scheme="primary"
      variant="solid"
      size="large"
    >
      {{ $t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.BTN_TEXT') }}
    </FormButton>
  </form>
</template>
